import React from "react";
import ProspectingPanel from "./ProspectingPanel";
import "./Scanner.css";

// Prospecting mode.
//
// Its own screen since the nav gained a fourth scanner item. It used to be a switch on
// External risk scan that swapped the whole form — which is the tell that it was never
// a mode of that screen: it posts to a different endpoint, files nothing against a
// customer organization, and ends in a report you download or send. The only thing the
// two genuinely share is the module picker, which still lives in ExternalRiskScan.jsx
// and is imported by the panel below.
const ProspectingScreen = () => (
  <div className="v2-page">
    <div className="v2-pagehead">
      <div>
        <h2>Prospecting mode</h2>
        <p>
          Scan a website without creating a customer organization. Download the report
          or send it to the prospect.
        </p>
      </div>
    </div>
    <ProspectingPanel />
  </div>
);

export default ProspectingScreen;
